import {Navigate, Outlet, Route, Routes, useNavigate,} from "react-router-dom";
import {Sidebar} from "./component/Sidebar";
import {Urls} from "../../component/const/Urls";
import {TestApp} from "./test/TestApp";
import {Test} from "./test/Test";
import {TestResult} from "./test/TestResult";
import {Qualification} from "./component/Qualification";
import {Transaction} from "./component/Transaction";
import {useEffect, useState} from "react";
import {Context} from "./component/context";
import {Searching} from "./component/Searching";
import {Profile} from "./myPage/Profile";
import {Alert} from "./myPage/Alert";
import {Ask} from "./myPage/Ask";
import Cancel from "./component/Cancel";
import Apply from "./component/Apply";
import {getEmail, getPw, login, logout} from "../../component/const/ForAuth";
import {TestCreate} from "./test/TestCreate";
import {TestGrading} from "./test/TestGrading";
import {TestFeedback} from "./test/TestFeedback";
import {TestGradingNotice} from "./test/TestGradingNotice";

export const List = () => {

    const [search, setSearch] = useState('')

    const na = useNavigate()
    useEffect(() => {
        login(getEmail(), getPw())
            .catch(err => {
                console.error(err)
                alert('회원 인증 과정에서 문제가 발생했습니다.\n다시 로그인해주세요.')
                logout()
                na('/')
            })
    }, []);

    return (
        <div className={'row px-18'}>
            <style>
                {`
          input,textarea {
          
          margin: 0 !important;
          }
        `}
            </style>
            <Sidebar/>
            <div className={'column'} id={"root-css"} style={{overflow: 'hidden', flexGrow: 1}}>
                <Context.Provider value={{search, setSearch}}>
                    <Searching/>
                    <div style={{overflow: 'scroll'}}>
                    <Routes>
                        <Route index element={<Navigate to={Urls.myPage+Urls.testApp}/>}/>
                        <Route path={Urls.testApp} Component={TestApp}/>
                        <Route path={Urls.test} Component={Test}/>
                        <Route path={Urls.testResult} Component={TestResult}/>
                        <Route path={Urls.qualification} Component={Qualification}/>
                        <Route path={Urls.transactions} Component={Transaction}/>
                        <Route path={Urls.profile} Component={Profile}/>
                        <Route path={Urls.alert} Component={Alert}/>
                        <Route path={Urls.ask} Component={Ask}/>
                        <Route path={Urls.create} Component={TestCreate}/>
                        <Route path={Urls.grade} Component={TestGrading}/>
                        <Route path={Urls.notice} Component={TestGradingNotice}/>
                        <Route path={Urls.feedback} Component={TestFeedback}/>
                        <Route path={Urls.cancel} Component={Cancel}/>
                        <Route path={Urls.apply} Component={Apply}/>
                    </Routes>
                    </div>
                </Context.Provider>
                <Outlet/>
            </div>
        </div>
    )
}